var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 18 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.618 2H6.382a2.245 2.245 0 0 0-2.239 2.24v10.52A2.245 2.245 0 0 0 6.383 17h6.235a2.245 2.245 0 0 0 2.24-2.24V4.24A2.245 2.245 0 0 0 12.617 2M9.5 15.393a.536.536 0 1 1 0-1.073.536.536 0 0 1 0 1.073m4.286-2.679H5.214V4.24a1.17 1.17 0 0 1 1.168-1.168h1.72l.145.295a1.4 1.4 0 0 0 2.507 0l.15-.295h1.714a1.17 1.17 0 0 1 1.168 1.168z"
})));
export default SvgPhone;